export enum LineAmountTypes {
    Exclusive = "Exclusive",
    Inclusive = "Inclusive",
    NoTax="NoTax"
    }